import { render, staticRenderFns } from "./RoleSummary.vue?vue&type=template&id=2ec489fd&scoped=true"
import script from "./RoleSummary.vue?vue&type=script&lang=js"
export * from "./RoleSummary.vue?vue&type=script&lang=js"
import style0 from "./RoleSummary.vue?vue&type=style&index=0&id=2ec489fd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec489fd",
  null
  
)

export default component.exports